








































import { defineComponent, computed, Ref, ref, watch, WritableComputedRef } from '@vue/composition-api';
import { ChevronDownIcon } from 'tdesign-icons-vue';
import { fileTypeToWording, FileSelectHandler } from '@/renderer/components/drawer/compositions/fileSelectHandler';
import { FileType } from '@/renderer/components/drawer/compositions/fileType';
class CheckableFileTypeItem {
  text: string;
  fileType: FileType;
  count: number;
  constructor(fileType: FileType, text: string, count: number) {
    this.text = text;
    this.fileType = fileType;
    this.count = count;
  }
}
export default defineComponent({
  name: 'FileFilter',
  components: {
    ChevronDownIcon,
  },
  props: {
    handler: {
      required: true,
      type: Object,
    },
  },
  setup(props, context) {
    const handler = props.handler as FileSelectHandler;

    // 选中的文件类型(通过这个cache实现UI层勾选变了，逻辑层的勾选列表等到下拉框收起时才变化)
    const checkedFileTypeListCache = ref(handler.filterFileTypeList.value);
    watch(
      () => [handler.filterFileTypeList.value, handler.manulFilterTypeList.value, handler.allFileTypeList.value],
      ([filterFileTypeList, manulFilterTypeList, allFileTypeList]) => {
        if (manulFilterTypeList === null) {
          checkedFileTypeListCache.value = allFileTypeList as FileType[];
        } else {
          checkedFileTypeListCache.value = filterFileTypeList as FileType[];
        }
      },
    );

    // 选中的文件类型（自动插入全部）
    const showCheckFileTypeList = computed(() => {
      const filterFileType = checkedFileTypeListCache.value;
      if (filterFileType.length === handler.allFileTypeList.value.length) {
        return [FileType.All, ...filterFileType];
      }
      return filterFileType;
    });

    // 可勾选项：由文件类型生成可勾选项
    const checkableItemList: WritableComputedRef<Array<CheckableFileTypeItem>> = computed(() => {
      const all = new CheckableFileTypeItem(
        FileType.All,
        fileTypeToWording(FileType.All),
        handler.fileList.value.length,
      );
      const itemList = handler.allFileTypeList.value.map(fileType => {
        const count = handler.fileList.value.filter(it => it.fileType === fileType).length;
        const fileTypeText = fileTypeToWording(fileType);
        return new CheckableFileTypeItem(fileType, fileTypeText, count);
      });
      return [all, ...itemList];
    });
    const methods = {
      // 处理dropdown消失
      handleVisibleChange(visible: boolean) {
        if (visible) return;
        handler.manulFilterTypeList.value = checkedFileTypeListCache.value;
      },
      // 处理item点击
      handleClick(data: any) {
        const item: CheckableFileTypeItem = data.value;
        const itemFileType = item.fileType;
        let currentCheckTypeList = [...checkedFileTypeListCache.value];
        if (showCheckFileTypeList.value.includes(itemFileType)) {
          if (itemFileType === FileType.All) {
            // 选中全部后取消全部
            currentCheckTypeList = [];
          } else {
            // 选中全选后取消某一项
            currentCheckTypeList = currentCheckTypeList.filter(it => it !== itemFileType);
          }
        } else if (itemFileType === FileType.All) {
          // 选中的全部
          currentCheckTypeList = handler.allFileTypeList.value;
        } else {
          // 选中某一项
          currentCheckTypeList.push(itemFileType);
        }
        checkedFileTypeListCache.value = currentCheckTypeList;
      },
      popupOverlayInnerStyle: (trigger: HTMLElement) => ({
        'margin-top': '0px',
      }),
      popUpOverlayStyle: (trigger: HTMLElement) => ({}),
    };
    return {
      checkableItemList,
      showCheckFileTypeList,
      ...methods,
    };
  },
});
